import React, { useState, useEffect } from 'react';
import { Button, Card, CardContent, Grid, Typography } from '@mui/material';
import { CustomButton } from '../../common/custom-button/customButton';
import { Box, Stack } from '@mui/system';
import { FinancialYearDropdown } from './FinancialYearDropdown';
import { GET_APPROVED_STAKEHOLDERS, GET_LLE_AHP, UPDATE_LLE_AHP, UPDATE_MONTHLY_MBR } from '../../common/URLs';

import { loaderService } from '../../common/custom-loader/loader-service';
import { toast } from 'react-toastify';
import { userData } from '../../common/spinLoader';
import { DataGrid, GridToolbarQuickFilter, GridToolbarExport, GridCellEditStopReasons, GridEditInputCell, useGridApiContext } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';

import DownloadIcon from '@mui/icons-material/Download';
import * as XLSX from 'xlsx';
import { DEMAND_CONSTANTS, DEMAND_ROLES, PROD } from '../../common/constants';
import { getLocalStorageItem } from '../../common/localStorageUtils';
import { styled } from '@mui/material/styles';
import { DEMAND_VALIDATIONS } from '../../common/commonValidations';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { ConfirmPopover } from '../../preregcamps/confirmPopover/confirmPopover';
import { ConfirmationPopover } from '../../common/commonPopovers/confirmationPopover';
import { useTranslation } from 'react-i18next';
import { SaveIcon } from '../../common/icons';
import apiClient from '../../axios';

export const LleAnnualHarvestingPotential = () => {
  const { t } = useTranslation();
  const uuid = localStorage.getItem('uuid');
  const [apiFormattedData, setApiFormattedData] = useState([]);
  const userLoggedIn = userData.user.userRoles?.[0].roleName
  const [selectedFinancialYear, setSelectedFinancialYear] = useState();
  const [combinedFinalMbrData, setCombinedFinalMbrData] = useState([]);
  const [lleData, setLleData] = React.useState([]);
  const [getStakeholderByTypeApiData, setGetStakeholderByTypeApiData] = useState([]);
  const [isAddDisabled, setIsAddDisabled] = React.useState(true);
  const [isSaveDisabled, setIsSaveDisabled] = React.useState(true);
  const [showAddLleBtn, setShowAddLleBtn] = React.useState(true);
  const [pageSize, setPageSize] = React.useState(10);

  const [saveAhpDialog, setSaveAhpDialog] = useState(false);
  const handleSaveAhpDialogOpen = () => setSaveAhpDialog(true);
  const handleSaveAhpDialogClose = () => setSaveAhpDialog(false);

  const StyledBox = styled(Box)(({ theme }) => ({
    height: "inherit",
    width: '100%',
    '& .MuiDataGrid-cell--editing': {
      backgroundColor: 'rgb(255,215,115, 0.19)',
      color: '#1a3e72',
      '& .MuiInputBase-root': {
        height: '100%',
      },
    },
    '& .Mui-error': {
      backgroundColor: `rgb(126,10,15, ${theme.palette.mode === 'dark' ? 0 : 0.1})`,
      color: theme.palette.error.main,
    },
  }));

  const StyledTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.error.main,
      color: theme.palette.error.contrastText,
    },
  }));

    function EditInputCell(props) {
          const { error, id, value: valueProp, field } = props;
          const [value, setValue] = useState(valueProp);
          const apiRef = useGridApiContext();
  
          const handleChange = (event) => {
              const newValue = event.target.value; 
              apiRef.current.setEditCellValue({ id, field, value: newValue });
              setValue(newValue);
          };
  
          useEffect(() => {
              setValue(valueProp);
          }, [valueProp]);
          
          return (
              <StyledTooltip open={!!error} title={error}>
                  <GridEditInputCell {...props} value={value} onChange={handleChange} />
             </StyledTooltip>
          );
      }

  function renderEdit(params) {
    return <EditInputCell {...params} />;
  }

  const columns = [
    { field: 'stakeholderURN', headerName: 'URN', width: 190 },
    { field: 'stakeholderType', headerName: 'Type', },
    { field: 'name', headerName: t('preReg.name'), width: 190 },
    { field: 'harvestingPotential', headerName: 'Harvesting Potential(in MT)', width: 200 },
    {
      field: 'Apr', headerName: 'APR', editable: (userLoggedIn === DEMAND_ROLES.DemandPlanner), type: 'number',
      preProcessEditCellProps: (params) => {
        return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
      },
      renderEditCell: renderEdit,
    },
    {
      field: 'May', headerName: 'MAY', editable: (userLoggedIn === DEMAND_ROLES.DemandPlanner), type: 'number',
      preProcessEditCellProps: (params) => {
        return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
      },
      renderEditCell: renderEdit,
    },
    {
      field: 'Jun', headerName: 'JUN', editable: (userLoggedIn === DEMAND_ROLES.DemandPlanner), type: 'number',
      preProcessEditCellProps: (params) => {
        return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
      },
      renderEditCell: renderEdit,
    },
    {
      field: 'Jul', headerName: 'JUL', editable: (userLoggedIn === DEMAND_ROLES.DemandPlanner), type: 'number',
      preProcessEditCellProps: (params) => {
        return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
      },
      renderEditCell: renderEdit,
    },
    {
      field: 'Aug', headerName: 'AUG', editable: (userLoggedIn === DEMAND_ROLES.DemandPlanner), type: 'number',
      preProcessEditCellProps: (params) => {
        return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
      },
      renderEditCell: renderEdit,
    },
    {
      field: 'Sep', headerName: 'SEP', editable: (userLoggedIn === DEMAND_ROLES.DemandPlanner), type: 'number',
      preProcessEditCellProps: (params) => {
        return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
      },
      renderEditCell: renderEdit,
    },
    {
      field: 'Oct', headerName: 'OCT', editable: (userLoggedIn === DEMAND_ROLES.DemandPlanner), type: 'number',
      preProcessEditCellProps: (params) => {
        return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
      },
      renderEditCell: renderEdit,
    },
    {
      field: 'Nov', headerName: 'NOV', editable: (userLoggedIn === DEMAND_ROLES.DemandPlanner), type: 'number',
      preProcessEditCellProps: (params) => {
        return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
      },
      renderEditCell: renderEdit,
    },
    {
      field: 'Dec', headerName: 'DEC', editable: (userLoggedIn === DEMAND_ROLES.DemandPlanner), type: 'number',
      preProcessEditCellProps: (params) => {
        return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
      },
      renderEditCell: renderEdit,
    },
    {
      field: 'Jan', headerName: 'JAN', editable: (userLoggedIn === DEMAND_ROLES.DemandPlanner), type: 'number',
      preProcessEditCellProps: (params) => {
        return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
      },
      renderEditCell: renderEdit,
    },
    {
      field: 'Feb', headerName: 'FEB', editable: (userLoggedIn === DEMAND_ROLES.DemandPlanner), type: 'number',
      preProcessEditCellProps: (params) => {
        return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
      },
      renderEditCell: renderEdit,
    },
    {
      field: 'Mar', headerName: 'MAR', editable: (userLoggedIn === DEMAND_ROLES.DemandPlanner), type: 'number',
      preProcessEditCellProps: (params) => {
        return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
      },
      renderEditCell: renderEdit,
    },
  ];

  const getSelectedValue = (dataToBePassed) => {
    setSelectedFinancialYear(dataToBePassed);
    getStakeholderByTypeApi(dataToBePassed);
    setIsAddDisabled(false);
    setIsSaveDisabled(false);
    setShowAddLleBtn(true);
  }
  const CustomToolbar = () => {
    const exportToExcel = (data) => {
      const ws = XLSX.utils.json_to_sheet(combinedFinalMbrData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Data");
      XLSX.writeFile(wb, "AnnualHarvestingPotential.xlsx");
    };
    return (
      <>
        <Box
          sx={{ p: 0.5, pb: 0, float: 'right' }}>
          <GridToolbarQuickFilter />
        </Box>
        <Box
          sx={{ p: 0.5, pb: 0, float: 'left' }}>
          <Button startIcon={<DownloadIcon />} onClick={() => exportToExcel(combinedFinalMbrData)}>Download</Button>

        </Box>
      </>

    );
  }

  const addLLEBtnApi = () => {
    let res = [];
    const temp = getStakeholderByTypeApiData === null || getStakeholderByTypeApiData?.length === 0 ? toast.info(DEMAND_CONSTANTS.NoDataMessage) :
      getStakeholderByTypeApiData?.map((data) => {
        let tempData = { ...data }
        tempData.harvestingPotential = 0
        return {
          'stakeholderURN': tempData.urn,
          'harvestingPotential': tempData.ahp,
          'stakeholderType': 'LLE',
          'name': tempData.name,
        }
      })
    res = temp?.filter(el => {
      return !lleData?.find(element => {
        return element.stakeholderURN === el.stakeholderURN;
      });
    });
    let finalData = [...res, ...lleData]
    setLleData(finalData);
    setShowAddLleBtn(false);
  }
  const processRowUpdate = (newRow, oldRow) => {
    const changedField = Object.keys(newRow).find(
      (key) => newRow[key] !== oldRow[key]
    );
    let data = {
      "stakeholderURN": newRow.stakeholderURN,
      "stakeholderType": "LLE",
      "month": changedField,
      "name": newRow.name,
      "harvestingPotential": parseFloat(newRow[changedField])
    }
    const arrTemp = [...apiFormattedData]
    if (arrTemp.length !== 0) {
      let filteredData = arrTemp.filter(item => item.stakeholderURN === data.stakeholderURN && item.month === data.month)
      if (filteredData.length === 0) arrTemp.push(data);
      else {
        arrTemp.map((item) => {
          if (item.stakeholderURN === data.stakeholderURN && item.month === data.month) {
            item.harvestingPotential = data.harvestingPotential
          }
        })
      }
    } else { arrTemp.push(data) }
    setApiFormattedData(arrTemp)
    lleData.forEach((item) => {
      if (item.stakeholderURN === newRow.stakeholderURN) {
        Object.keys(newRow).map((rowItem) => item[rowItem] = newRow[rowItem])
        item.type = "new"
      }
    })
    return newRow
  }
  
  // -----------------API Calls-------------------

  const getStakeholderByTypeApi = async (dataToBePassed) => {
    loaderService.showLoader();
    await apiClient.post(GET_APPROVED_STAKEHOLDERS,
      {
        type: 'LLE'
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          "Content-Type": "application/json"
        }
      })
      .then((response) => {
        const temp = response?.data?.stakeHolders
        setGetStakeholderByTypeApiData(temp);
        getLleAHP(dataToBePassed, temp, 'firstCall');
        loaderService.hideLoader();

      }).catch(function (error) {
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  const getLleAHP = (year, response2, type) => {
    loaderService.showLoader();
    apiClient.post(GET_LLE_AHP + `?userId=${uuid}`,
      {
        "financialYear": year,
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          "Content-Type": "application/json"
        }
      })
      .then((response) => {
        let response1 = response?.data?.lleAhpLst;
        if (type === 'firstCall') {
          const result = response1.map((data1) => {
            const matchingData2 = response2?.find((data2) => {
              const data1Id = data1.stakeholderURN;
              const data2Id = data2.urn;
              return data2Id === data1Id
            });
            return Object.assign({}, data1, matchingData2);
          })
          let finalData = result?.map((item) => {
            let mhp = item?.monthWiseHarvestingPotential
            return {
              'stakeholderURN': item.stakeholderURN,
              'harvestingPotential': item.ahp,
              'stakeholderType': 'LLE',
              'name': item.name,
              'Apr': mhp.Apr ? mhp.Apr : 0,
              'May': mhp.May ? mhp.May : 0,
              'Jun': mhp.Jun ? mhp.Jun : 0,
              'Jul': mhp.Jul ? mhp.Jul : 0,
              'Aug': mhp.Aug ? mhp.Aug : 0,
              'Sep': mhp.Sep ? mhp.Sep : 0,
              'Oct': mhp.Oct ? mhp.Oct : 0,
              'Nov': mhp.Nov ? mhp.Nov : 0,
              'Dec': mhp.Dec ? mhp.Dec : 0,
              'Jan': mhp.Jan ? mhp.Jan : 0,
              'Feb': mhp.Feb ? mhp.Feb : 0,
              'Mar': mhp.Mar ? mhp.Mar : 0,
            }
          })
          setLleData(finalData);
        } else if (type === 'afterUpdateCall') {
          let finalData = response1?.map((item) => {
            let mhp = item?.monthWiseHarvestingPotential
            return {
              'stakeholderURN': item.stakeholderURN,
              'harvestingPotential': item.ahp,
              'stakeholderType': 'LLE',
              'name': item.name,
              'Apr': mhp.Apr ? mhp.Apr : 0,
              'May': mhp.May ? mhp.May : 0,
              'Jun': mhp.Jun ? mhp.Jun : 0,
              'Jul': mhp.Jul ? mhp.Jul : 0,
              'Aug': mhp.Aug ? mhp.Aug : 0,
              'Sep': mhp.Sep ? mhp.Sep : 0,
              'Oct': mhp.Oct ? mhp.Oct : 0,
              'Nov': mhp.Nov ? mhp.Nov : 0,
              'Dec': mhp.Dec ? mhp.Dec : 0,
              'Jan': mhp.Jan ? mhp.Jan : 0,
              'Feb': mhp.Feb ? mhp.Feb : 0,
              'Mar': mhp.Mar ? mhp.Mar : 0,
            }
          })
          setLleData(finalData);
        };

        loaderService.hideLoader();
      }).catch(function (error) {
        toast.error(error.message)
        loaderService.hideLoader();
      });
  }

  const onConfirmSaveAhp = () => {
    handleSaveAhpDialogClose();
    loaderService.showLoader();
    apiClient.post(UPDATE_LLE_AHP + `?userId=${uuid}`,
      {
        "financialYear": selectedFinancialYear,
        "lleLst": apiFormattedData
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          "Content-Type": "application/json"
        }
      })
      .then((response) => {
        toast.success(response.data.message);
        getLleAHP(selectedFinancialYear, [], 'afterUpdateCall')
        setShowAddLleBtn(true);
        setApiFormattedData([]);
        loaderService.hideLoader();
      }).catch(function (error) {
        toast.error(error.message)
        loaderService.hideLoader();
      });
  }

  const updateLleAHP = (year) => {
    handleSaveAhpDialogOpen();
  }

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} lg={12}>
        {!PROD && <p style={{ textAlign: "right", fontSize: "2vh" }}>DEM08</p>}
        <Card style={{ marginBottom: 10 }}>
          <CardContent>
            <Grid container spacing={1}>
              <Grid item xs={12} lg={2}>
                <FinancialYearDropdown selectedValue={getSelectedValue} />
              </Grid>
              {userLoggedIn === DEMAND_ROLES.DemandPlanner &&
                <Grid item xs={12} lg={10} >
                  <Stack direction="row" spacing={1} style={{ float: 'right' }}>
                    <CustomButton startIcon={<SaveIcon />} title="Save AHP" disabled={isSaveDisabled} onClick={() => updateLleAHP()} />
                    {showAddLleBtn && <Button variant="contained" startIcon={<AddIcon />} disabled={isAddDisabled} onClick={() => addLLEBtnApi()}>Add LLE</Button>}
                  </Stack>
                </Grid>}
            </Grid>
          </CardContent>
        </Card>
        <Card>
          <CardContent>
            <Box sx={{
              height: '300', width: '100%', display: "flex",
              justifyContent: "center",
              alignItems: "center",
              '& .super-app-theme--header': {
                wordWrap: 'break-word',
                wordBreak: 'break-all',
                whiteSpace: 'initial',
              },
              '& .MuiDataGrid-cell--editable': {
                bgcolor: (theme) =>
                  theme.palette.mode === 'dark' ? '#376331' : 'rgb(217 243 190)',
              },
              '& .Mui-error': {
                                backgroundColor: `rgb(126,10,15,0.1)`,
                                color: (theme) => theme.palette.error.main,
                            },
            }}>
             
                <DataGrid
                  autoHeight
                  columns={columns}
                  rows={lleData}
                  processRowUpdate={processRowUpdate}
                  getRowId={(row) => row.stakeholderURN}
                  components={{ Toolbar: CustomToolbar }}
                  experimentalFeatures={{ newEditingApi: true }}
                  pageSize={pageSize}
                  onPageSizeChange={(newPage) => setPageSize(newPage)}
                />
              
            </Box>
          </CardContent>
        </Card>
      </Grid>
      <ConfirmationPopover onOpen={saveAhpDialog} onConfirm={onConfirmSaveAhp} onClose={handleSaveAhpDialogClose} action="Save AHP" />
    </Grid>
  );
}
